import { reactive } from 'vue'
import { AuthService } from '@/services/auth'

export const authStore = reactive({
  user: AuthService.getUserData(),
  isAuthenticated: AuthService.isAuthenticated(),
  credits: 0,
  creditsLoading: false,
  appointmentMode: false,
  restaurantMode: false,

  setUser (userData) {
    this.user = userData
    this.isAuthenticated = true
  },

  clearUser () {
    this.user = null
    this.isAuthenticated = false
    this.credits = 0
    this.appointmentMode = false
    this.restaurantMode = false
    AuthService.logout()
  },

  setAppointmentMode (isAppointmentMode) {
    this.appointmentMode = isAppointmentMode
  },

  setRestaurantMode (isRestaurantMode) {
    this.restaurantMode = isRestaurantMode
  },

  async login (credentials) {
    const response = await AuthService.login(credentials)
    AuthService.setAuthData(response)
    this.setUser(response.user)
    // Load credits after successful login
    this.loadCredits()
    return response
  },

  logout () {
    this.clearUser()
  },

  async loadCredits () {
    this.creditsLoading = true
    try {
      const creditsData = await AuthService.getUserCredits()
      this.credits = creditsData.credits || 0
    } catch (error) {
      console.error('Failed to load credits:', error)
      this.credits = 0
    } finally {
      this.creditsLoading = false
    }
  }
})
